import { Moment } from "moment";

export class AddNofeshAdmin
{
    id_nofesh: number;
    nofesh_title:string
    tentitive:boolean
    id_nofesh_type:number
    rishum_from:Moment
    rishum_to:Date
    nofesh_from:Date
    nofesh_to:Date
    total_rooms:number;
    total_peaple:number;
    board_type:number;
    company:string;
    companySite:string;
    hotelName:string;
    heara1:string;
    heara2:string;
    heara3:string;
    isSyllabusUploaded:boolean;
    hotel_star_rating:number;
    total_hamtana_room:number;
    total_hamtana_people:number;
    child_min_age:number;
    child_max_age:number;
    id_nofesh_mekushar:number;
    id_machzor:number;
    k_pail:number;
    shana:number;
    price_id_1:number;
    price_id_2:number;
    price_id_3:number;
    price_id_4:number;
    price_id_5:number;
    price_id_6:number;
    price_id_7:number;
    price_id_19:number;
    price_id_15:number;
    price_id_16:number;
    price_id_17:number;    
    price_id_11:number;
    price_id_12:number;
    price_id_13:number;
    sug_cheder:number;
    teur_sug_cheder:string
    numberOfRooms:number;
    numberOfRoomsHamtana:number;
}